module.exports = __webpack_public_path__ + "static/media/hagrid.39b714e7.jpg";